import { memo } from 'react';
import UseDfpSlot from './UseDfpSlot';

const Caja3 = () => {

    UseDfpSlot({
        path: '/28253241/elcomercio/web/post/especiales/caja3',
        size: ['fluid', [300, 100], [300, 50], [300, 250], [320, 100], [320, 50]],
        id: 'div-gpt-ad-1595369596954-0',
    });

    return (
        <section className="container my-3 pt-3 d-xl-none text-center container-caja3">
            <div id="div-gpt-ad-1595369596954-0"></div> 
        </section>
    )
}

export default memo(Caja3);
